module.exports = __webpack_public_path__ + "0c548de47ff626c1205a48d2057e4c44.png";


//////////////////
// WEBPACK FOOTER
// ./app/images/infinite-logo-web-hi-res.png
// module id = 127
// module chunks = 1